<script lang="ts">
  import { settingsStore } from "../../lib/stores/settings";
  import { setupMap, updateMapWithDeliveryZones } from "../../lib/helpers/map";
  import maplibregl from "maplibre-gl";
  import { getCopy } from "../../lib/stores/copy";
  import CustomHtml from "../CustomHTML.svelte";
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  // TODO: add conditional route, route path

  export let currentRoute;

  let container: HTMLDivElement;
  let map: maplibregl.Map;

  const setupAndUpdateMap = (deliveryZones: Array<Array<number[]>>) => {
    if (container && !map) {
      map = setupMap(container, {
        scrollZoom: true,
        dragPan: true,
        interactive: true
      });

      map.on("load", () => {
        void updateMapWithDeliveryZones(map, deliveryZones);
      });
    }
  };

  $: container, void setupAndUpdateMap($settingsStore.deliveryZones as Array<Array<number[]>>);
  $: copy = $getCopy("deliveryZones") as Record<string, string>;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} />
    <CustomHtml customHtml={copy.subHeaderCopy} />

    <!-- overflow-hidden required, because the map with cover the round corners otherwise -->
    <div aria-label="map" class="relative w-full h-full rounded-lg overflow-hidden mt-4">
      <div class="w-full h-full min-h-80" bind:this={container}></div>
    </div>
  </svelte:fragment>
</BaseStep>
